module Users {
    export function Init(): void {
        if (window.location.pathname == "/Users/LogIn") {
            $('#2FaModal').hide();
            Notifications.GetNotification("Morate biti prijavljeni u aplikaciju", "danger");
        }
        else if (window.location.pathname == "/User/UserDashboard" && Cookies.get("FirstTime") != undefined) {
        }

        $('#submitBtn').on('click', function () {
            var $btn = $(this);

            if ($btn.data('loading')) return;
            $btn.data('loading', true);

            var $text = $btn.find('.btn-text');

            var $spinner = $('<span class="button-spinner"></span>');
            $text.after($spinner);
        });
    }
}

module UserDashboard {
    var _charts: any[] = [];
    var _resizeTimer: any;

    export function Init(): void {
        var dataTableSettings: DataTables.Settings = {
            lengthChange: false,
            searching: false
        };

        var columnDef: DataTables.ColumnDefsSettings[] = [
            {
                targets: [1, 2, 3, 4, 5, 6, 7],
                orderable: false
            },
            {
                targets: [1, 2, 3, 4, 5, 6],
                width: '36px',
                className: 'spc-td-icon'
            },
            {
                targets: [7],
                width: '44px',
                className: 'spc-td-actions'
            }
        ];

        Common.DataTableCustom.Init("scriptTable", dataTableSettings, columnDef);

        $('#scriptTable').on('click', '.user-dsh-script-details', function () {
            var scriptId = $(this).data("id-script");
            Dialog.OpenDetailsModal('Detalji skripte', '/Script/Details/' + scriptId);
        });
    }

    export function InitPieChart(chartData: any) {
        var label = new Array();
        var value = new Array();

        for (var i = 0; i < chartData.length; i++) {
            label.push(chartData[i].shortName);
            value.push(chartData[i].count);
        }

        _charts = _charts.filter(c => c.canvas && c.canvas.id !== 'pie-chart');
        var myPieChart = new Chart("pie-chart", {
            type: 'doughnut',
            data: {
                datasets: [{
                    backgroundColor: ["#FDD30F", "#FDB50F", "#FD970F", "#EA4541", "#C53A37", "#A02F2D", "#51AA54", "#459047", "#38763A", "#6B25FD", "#641AFD", "#5C0FFD"],
                    data: value
                }],
                labels: label
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                title: {
                    display: false
                },
                legend: {
                    display: true,
                    position: "bottom",
                    labels: {
                        boxWidth: 10,
                        fontSize: 8
                    }
                },
                animation: {
                    animateRotate: true,
                    animateScale: true,
                    duration: 4000
                },
                cutoutPercentage: 50
            }
        });
        _charts.push(myPieChart);
    }

    var _lastLineChartData: any = null;

    export function InitLineChart(chartData: any) {
        _lastLineChartData = chartData;
        var label = new Array();
        var value = new Array();

        for (var i = 0; i < chartData.length; i++) {
            label.push(chartData[i].labels);
            value.push(chartData[i].value);
        }

        const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
        const lineColor = isDark ? 'white' : '#333';
        const gridColor = isDark ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.1)';
        const tickColor = isDark ? 'white' : '#666';

        const existingLine = _charts.find(c => c.canvas && c.canvas.id === 'line-chart');
        if (existingLine) { try { existingLine.destroy(); } catch (e) {} }
        _charts = _charts.filter(c => c.canvas && c.canvas.id !== 'line-chart');
        var mylineChart = new Chart("line-chart", {
            type: 'line',
            data: {
                labels: label,
                datasets: [{
                    data: value,
                    label: "Br. skripti",
                    borderColor: lineColor,
                    borderWidth: 2,
                    pointStyle: "rectRounded",
                    pointBorderColor: lineColor
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                title: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        ticks: { fontColor: tickColor },
                        gridLines: { color: gridColor, zeroLineColor: gridColor }
                    }],
                    yAxes: [{
                        ticks: { fontColor: tickColor },
                        gridLines: { color: gridColor, zeroLineColor: gridColor }
                    }]
                },
                legend: {
                    labels: { fontColor: tickColor }
                }
            }
        });
        _charts.push(mylineChart);

        $(window).off('resize.userDshCharts').on('resize.userDshCharts', function () {
            clearTimeout(_resizeTimer);
            _resizeTimer = setTimeout(function () {
                _charts.forEach(function (c) { c.resize(); });
            }, 100);
        });

        // Re-init with correct colors when theme changes
        document.removeEventListener('skr-theme-changed', _onThemeChanged as EventListener);
        document.addEventListener('skr-theme-changed', _onThemeChanged as EventListener);
    }

    function _onThemeChanged() {
        if (_lastLineChartData) {
            InitLineChart(_lastLineChartData);
        }
    }
}